import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getIcon,
  getMenuClasses,
  ifSubmenuSelected,
  checkPermissionForNonMember,
  checkPermissionForEmployer,
  checkBlockedRoutes,
} from "../../config/helpers";

import constants from "../../config/constants";
import "./styles.css";
import authActions from "../../redux/auth/action";

import CustomLoader from "../CustomLoader/CustomLoader";

class Sidebar extends Component {
  state = {
    openedMenu: "",
    isLoading: false,
  };

  navigate = async (route) => {
    const { localHistory, closeSidebar, alertBox, user } = this.props;

    if (!checkBlockedRoutes(route)) {
      return;
    }
    if (user.roles.length > 1) {
      const shouldNotNavigate = await this.checkDoubleRolePermission(route);

      if (shouldNotNavigate) {
        alertBox({
          type: "error",
          message: "You are not authorized for this!",
        });
        return;
      }
    } else if (!this.checkPermission(route)) {
      alertBox({ type: "error", message: "You are not authorized for this!" });
      return;
    }

    localHistory.push(route);
    closeSidebar();
    this.setState({}); // Temporary fix to run render function
  };

  checkDoubleRolePermission = async (route) => {
    const { user } = this.props;

    //Only checking permissions assigned to user
    const isNonMember = user.roles.some(
      (item) => item.roleId === constants.NON_MEMBER_CODE
    );
    const isMember = user.roles.some(
      (item) => item.roleId === constants.MEMBER_CODE
    );
    const isAgent = user.roles.some(
      (item) => item.roleId === constants.AGENT_CODE
    );
    const isEmployer = user.roles.some(
      (item) => item.roleId === constants.EMPLOYER_CODE
    );
    const isStaff = user.roles.some(
      (item) => item.roleId === constants.STAFF_CODE
    );

    let arrayOfRoute = [];

    //Pushing all routes which are restricted for current user
    if (isNonMember) {
      arrayOfRoute.push(constants.NON_MEMBER_RESTRICTED_ROUTES);
    }
    if (isMember) {
      arrayOfRoute.push(constants.MEMBER_RESTRICTED_ROUTES);
    }
    if (isAgent) {
      arrayOfRoute.push(constants.AGENT_RESTRICTED_ROUTES);
    }
    if (isEmployer) {
      arrayOfRoute.push(constants.EMPLOYER_RESTRICTED_ROUTES);
    }
    if (isStaff) {
      arrayOfRoute.push(constants.STAFF_RESTRICTED_ROUTES);
    }

    //Intersecting multiple arrays to get all restricted routes for current user
    const finalRestrictedRoutes = await this.intersection(arrayOfRoute);

    //Checking if current route is restricted for current user
    route = route.replace("/", "");

    const shouldNotNavigate = finalRestrictedRoutes.some(
      (item) => item === route
    );

    return shouldNotNavigate;
  };

  intersection = (arrayOfRoute) => {
    // Temporary fix to remove "/" from every routes
    for (let i = 0; i < arrayOfRoute.length; i++) {
      for (let j = 0; j < arrayOfRoute[i]?.length; j++) {
        arrayOfRoute[i][j] = arrayOfRoute[i][j].replace("/", "");
      }
    }

    // Intersection of all arrays
    const restrictedRoutes = arrayOfRoute.reduce((array1, array2) =>
      array1.filter((route) => array2.includes(route))
    );

    return restrictedRoutes;
  };

  checkPermission = (route) => {
    const { user } = this.props;
    const isNonMember = user.roles.some(
      (item) => item.roleId === constants.NON_MEMBER_CODE
    );
    const isMember = user.roles.some(
      (item) => item.roleId === constants.MEMBER_CODE
    );

    if (isNonMember) {
      return checkPermissionForNonMember(route);
    }

    const isEmployer = user.roles.some(
      (item) => item.roleId === constants.EMPLOYER_CODE
    );

    if (isEmployer) return checkPermissionForEmployer(route);
    if (
      !isEmployer &&
      (route === "submissionreport" || route === "outputscreen")
    ) {
      return false;
    }

    if (!isEmployer && !isMember && route === "requestemployercode")
      return false;

    return true;
  };

  renderSubmenu = (type) => {
    const { localHistory } = this.props;
    const { openedMenu } = this.state;
    const path = localHistory && localHistory.location.pathname;

    if (type === "accountinfo" && openedMenu === "accountinfo") {
      return (
        <ul>
          <li
            onClick={this.navigate.bind(this, "/currentbalance")}
            className={getMenuClasses(path === "/currentbalance")}
          >
            Current Balance
          </li>
          <li
            className={getMenuClasses(path === "/transactiondetails")}
            onClick={this.navigate.bind(this, "transactiondetails")}
          >
            Transaction Details
          </li>
        </ul>
      );
    }

    if (type === "enquires" && openedMenu === "enquires") {
      return (
        <ul>
          <li
            onClick={this.navigate.bind(this, "pensioncalculator")}
            className={getMenuClasses(path === "/pensioncalculator")}
          >
            Pension Calculator
          </li>
          <li
            className={getMenuClasses(path === "/fundprices")}
            onClick={this.navigate.bind(this, "fundprices")}
          >
            Fund Prices
          </li>
          <li
            onClick={this.navigate.bind(this, "referral")}
            className={getMenuClasses(path === "/referral")}
          >
            Referral
          </li>
          <li
            onClick={this.navigate.bind(this, "rewardsystem")}
            className={getMenuClasses(path === "/rewardsystem")}
          >
            Reward System
          </li>
          <li
            onClick={this.navigate.bind(this, "submissionreport")}
            className={getMenuClasses(path === "/submissionreport")}
          >
            Schedule Submission Report
          </li>
          <li
            onClick={this.navigate.bind(this, "outputscreen")}
            className={getMenuClasses(path === "/outputscreen")}
          >
            Upload Reports
          </li>
          <li
            onClick={this.navigate.bind(this, "requestemployercode")}
            className={getMenuClasses(path === "/requestemployercode")}
          >
            Request Employer Code
          </li>
        </ul>
      );
    }

    if (type === "profilesetting" && openedMenu === "profilesetting") {
      return (
        <ul>
          <li
            onClick={this.navigate.bind(this, "personaldetails")}
            className={getMenuClasses(path === "/personaldetails")}
          >
            Personal Details
          </li>
          <li
            onClick={this.navigate.bind(this, "nextofkin")}
            className={getMenuClasses(path === "/nextofkin")}
          >
            Next of Kin
          </li>
          <li
            onClick={this.navigate.bind(this, "employeedetails")}
            className={getMenuClasses(path === "/employeedetails")}
          >
            Employer Details
          </li>
          <li
            onClick={this.navigate.bind(this, "changepassword")}
            className={getMenuClasses(path === "/changepassword")}
          >
            Change Password
          </li>
          <li
            onClick={this.navigate.bind(this, "addrole")}
            className={getMenuClasses(path === "/addrole")}
          >
            Add Role
          </li>
        </ul>
      );
    }

    if (type === "micropension" && openedMenu === "micropension") {
      return (
        <ul>
          {/* <li
            onClick={this.navigate.bind(this, "onboarding")}
            className={getMenuClasses(path === "/onboarding")}
          >
            Onboarding
          </li> */}
          <li
            onClick={this.navigate.bind(this, "contribution")}
            className={getMenuClasses(path === "/contribution")}
          >
            Contribution
          </li>
          <li
            onClick={this.navigate.bind(this, "withdrawal")}
            className={getMenuClasses(path === "/withdrawal")}
          >
            Withdrawal
          </li>
        </ul>
      );
    }

    if (type === "enrollment" && openedMenu === "enrollment") {
      return (
        <ul>
          <li
            onClick={this.navigate.bind(this, "onboarding")}
            className={getMenuClasses(path === "/onboarding")}
          >
            Micro Pension PIN Registration
          </li>
          {/* <li
            onClick={this.navigate.bind(this, "micropension-duplicate")}
            className={getMenuClasses(path === "/micropension-duplicate")}
          >
            Micro Pension PIN Registration Duplicate
          </li> */}
          <li
            onClick={this.navigate.bind(this, "rsapin")}
            className={getMenuClasses(path === "/rsapin")}
          >
            RSA PIN Registration
          </li>
        </ul>
      );
    }
  };

  toggleSubmenu = (menu) => {
    const { openedMenu } = this.state;

    if (menu === "accountinfo") {
      this.navigate("/currentbalance");
    }
    if (menu === "enquires") {
      this.navigate("/pensioncalculator");
    }
    if (menu === "profilesetting") {
      this.navigate("/personaldetails");
    }
    if (menu === "micropension") {
      this.navigate("/contribution");
    }
    if (menu === "enrollment") {
      this.navigate("/onboarding");
    }
    this.setState({ openedMenu: menu === openedMenu ? "" : menu });
  };

  decideSidebar = () => {
    const { isSidebar } = this.props;
    const width = window.innerWidth;

    if (width > 650 || isSidebar) return false;

    return true;
  };

  closeSidebar = () => {
    const { closeSidebar } = this.props;
    closeSidebar();
  };

  openExpressionOfInterest = () => {
    window.open(
      "https://datarecapture.premiumpension.com/expressinterest/Home/",
      "_blank"
    );
  };

  render() {
    const { isLoading } = this.state;
    const { localHistory } = this.props;
    const path = localHistory && localHistory.location.pathname;

    return (
      <div
        className={`sidebar-container ${
          !this.decideSidebar() && "sidebar-open"
        }`}
      >
        <div className="sidebar-cancel-container m-1 py-1 px-3">
          <img
            onClick={() => this.closeSidebar()}
            alt="close-icon"
            src={require("../../assets/icons/cancel.svg")}
            width="15px"
          />
        </div>
        <div className="sidebar-header">
          <img
            alt="app-icon"
            src={require("../../assets/icons/app-icon.png")}
            className="sidebar-header-icon"
          />
          <p>Premium Pension Limited</p>
        </div>
        <ul className="sidebar-outer-main-menu">
          <li onClick={this.navigate.bind(this, "/")}>
            <div>
              <img
                alt="home"
                className="sidebar-menu-icon"
                src={getIcon("home", path === "/")}
              />
              <p className={getMenuClasses(path === "/")}>Home</p>
            </div>
          </li>
          <li>
            <div onClick={this.toggleSubmenu.bind(this, "micropension")}>
              <img
                alt="micro-pension"
                className="sidebar-menu-icon"
                src={getIcon(
                  "micropension",
                  ifSubmenuSelected("micropension", path)
                )}
              />
              <p className={getMenuClasses(path === "/micropension")}>
                Micro Pension
              </p>
            </div>
            {this.renderSubmenu("micropension")}
          </li>
          <li>
            <div onClick={this.toggleSubmenu.bind(this, "enrollment")}>
              <img
                alt="enrollment"
                className="sidebar-menu-icon"
                src={getIcon(
                  "enrollment",
                  ifSubmenuSelected("enrollment", path)
                )}
              />
              <p className={getMenuClasses(path === "/enrollment")}>
                Enrollment
              </p>
            </div>
            {this.renderSubmenu("enrollment")}
          </li>
          <li>
            <div onClick={this.toggleSubmenu.bind(this, "accountinfo")}>
              <img
                alt="account-info"
                className="sidebar-menu-icon"
                src={getIcon(
                  "accountinfo",
                  ifSubmenuSelected("accountinfo", path)
                )}
              />
              <p className={getMenuClasses(path === "/accountinfo")}>
                Account Info
              </p>
            </div>
            {this.renderSubmenu("accountinfo")}
          </li>
          <li>
            <div onClick={this.toggleSubmenu.bind(this, "enquires")}>
              <img
                alt="enquires"
                className="sidebar-menu-icon"
                src={getIcon("enquires", ifSubmenuSelected("enquires", path))}
              />
              <p className={getMenuClasses(path === "/enquires")}>Enquiries</p>
            </div>
            {this.renderSubmenu("enquires")}
          </li>
          <li onClick={() => this.openExpressionOfInterest()}>
            <div>
              <img
                alt="expression-of-interest"
                className="sidebar-menu-icon"
                src={getIcon("enquires", path === "/expression-of-interest")}
              />
              <p className={getMenuClasses(path === "/expression-of-interest")}>
                Expression of interest
              </p>
            </div>
          </li>
        </ul>
        <div className="seperator" />
        <ul className="sidebar-outer-bottom-menu">
          <li>
            <div onClick={this.toggleSubmenu.bind(this, "profilesetting")}>
              <img
                alt="enquires"
                className="sidebar-menu-icon"
                src={getIcon(
                  "profilesetting",
                  ifSubmenuSelected("profilesetting", path)
                )}
              />
              <p className={getMenuClasses(path === "/profilesetting")}>
                Profile Setting
              </p>
            </div>
            {this.renderSubmenu("profilesetting")}
          </li>
          <li onClick={this.navigate.bind(this, "downloadforms")}>
            <div>
              <img
                alt="download"
                className="sidebar-menu-icon"
                src={getIcon("downloadforms", path === "/downloadforms")}
              />
              <p className={getMenuClasses(path === "/downloadforms")}>
                Download Forms
              </p>
            </div>
          </li>
          <li>
            <div>
              <img
                alt="self-service"
                className="sidebar-menu-icon"
                src={getIcon("selfservice", path === "/selfservice")}
              />
              <p
                className={getMenuClasses(path === "/selfservice")}
                onClick={this.navigate.bind(this, "selfservice")}
              >
                Self Service
              </p>
            </div>
          </li>
          <li onClick={this.navigate.bind(this, "/contactus")}>
            <div>
              <img
                alt="contact"
                className="sidebar-menu-icon"
                src={getIcon("contactus", path === "/contactus")}
              />
              <p className={getMenuClasses(path === "/contactus")}>
                Contact Us
              </p>
            </div>
          </li>
          <li onClick={this.navigate.bind(this, "/faq")}>
            <div>
              <img
                alt="faq"
                className="sidebar-menu-icon"
                src={getIcon("faq", path === "/faq")}
              />
              <p className={getMenuClasses(path === "/faq")}>FAQs</p>
            </div>
          </li>
        </ul>
        {isLoading && <CustomLoader text="Please wait" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  localHistory: state.history.localHistory,
  isSidebar: state.auth.isSidebar,
});

const mapDispatchToProps = {
  alertBox: authActions.setAlertMessage,
  removeUser: authActions.removeUser,
  closeSidebar: authActions.closeSidebar,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
